import { Injectable } from '@angular/core';
import { MomentService } from '../moment/moment.service';


@Injectable()
export class FiltersService {

  public filters:any = {};
  public isFiltering: boolean = false;

  // individual filter setup
  public filterTransportationMode: boolean;
  public filterOrigin: boolean;
  public filterDestination: boolean;
  public filterShipDate: boolean;
  public filterArrivalDate: boolean;
  public filterEquipmentId: boolean;
  public filterReferenceNumber: boolean;
  public filterSearchAllRecords: boolean;

  public appliedFilterCount: number = 0;
  public updateAppliedFilterCount() {
    let count = 0;

    if(this.filterTransportationMode) count++;
    if(this.filterOrigin) count++;
    if(this.filterDestination) count++;
    if(this.filterShipDate) count++;
    if(this.filterArrivalDate) count++;
    if(this.filterEquipmentId) count++;
    if(this.filterReferenceNumber) count++;
    if(this.filterSearchAllRecords) count++;

    this.appliedFilterCount = count;
  }

  public transportationModeOptions = [
    { label: 'IML', value: ['IML', 'RLC'] },
    { label: 'LTL', value: ['LTL'] },
    { label: 'TL', value: ['TL','HWY']},
    { label: 'BULK', value: ['BULK'] }
  ];
  public filterTransportationModeSelect = this.transportationModeOptions[0];

  public origins: {}[] = [];
  public destinations: {id: number}[] = [];
  public dateComparisonOptions = [
    { label: 'Equals', value: 'equals' },
    { label: 'Inbetween', value: 'inbetween' },
    { label: 'After', value: 'after' },
    { label: 'Before', value: 'before' }
  ];

  public filterShipDateSelect: string = 'equals';
  public filterShipDateInput1: any;
  public filterShipDateInput2: any;

  public filterArrivalDateSelect: string = 'equals';
  public filterArrivalDateInput1: any;
  public filterArrivalDateInput2: any;

  public filterEquipmentIdValue: string;
  public filterReferenceNumberValue: string;

  constructor( private momentService: MomentService ) { }

  public clear():void {
    this.filters = {};
    this.isFiltering = false;

    this.filterTransportationMode = false;

    this.filterOrigin = false;
    this.origins = [];

    this.filterDestination = false;
    this.destinations = [];

    this.filterShipDate = false;
    this.filterShipDateSelect = 'equals';
    this.filterShipDateInput1 = {}
    this.filterShipDateInput2 = ''

    this.filterArrivalDate = false;
    this.filterArrivalDateSelect = 'equals';
    this.filterArrivalDateInput1 = ''
    this.filterArrivalDateInput2 = ''

    this.filterEquipmentId = false;
    this.filterEquipmentIdValue = '';

    this.filterReferenceNumber = false;
    this.filterReferenceNumberValue = '';

    this.filterSearchAllRecords = false;
    this.updateAppliedFilterCount();
  }

  public clearByCategory(category){
    switch (category){
      case 'trans_mode':
        this.filterTransportationMode = false;
        break;
      case 'origin':
        this.filterOrigin = false;
        this.origins = [];
        break;
      case 'destination':
        this.filterDestination = false;
        this.destinations = [];
        break;
      case 'ship_date':
        this.filterShipDate = false;
        this.filterShipDateSelect = 'equals';
        this.filterShipDateInput1 = {};
        this.filterShipDateInput2 = '';
        break;
      case 'arrival_date':
        this.filterArrivalDate = false;
        this.filterArrivalDateSelect = 'equals';
        this.filterArrivalDateInput1 = '';
        this.filterArrivalDateInput2 = '';
      case 'equipment_id':
        this.filterEquipmentId = false;
        this.filterEquipmentIdValue = '';
        break;
      case 'reference_number':
        this.filterReferenceNumber = false;
        this.filterReferenceNumberValue = '';
    }
    this.updateAppliedFilterCount();
    this.filter();
  }

  private formatLocations(collection): {} {
    return collection.map((selectedLocation:string) => {
      let val = selectedLocation.split(',');
      let location: { city: string, state: string, zip_code: string } = { city: '', state: '', zip_code: '' };

      switch (val[2]) {
        case "zip_code":
          location.zip_code = val[0];
          break;
        case "state":
          location.state = val[0];
          break;
        case "city_state":
          location.city = val[0];
          location.state = val[1];
          break;
        default:
          break;
      }

      return location;
    });
  }

  public filter():void {
    this.filters = {};

    if (this.filterTransportationMode) {
      this.filters.trans_mode = this.filterTransportationModeSelect.value;
      this.filters.trans_mode.select = this.filterTransportationModeSelect.label;
    }

    if( this.filterOrigin ) {
      if(!this.origins.length) {
        this.filterOrigin = false;
      } else {
        this.filters.origin = this.formatLocations(this.origins);
      }
    }

    if( this.filterDestination ) {
      if(!this.destinations.length) {
        this.filterDestination = false;
      } else {
        this.filters.destination = this.formatLocations(this.destinations);
      }
    }

    if( this.filterShipDate && this.filterShipDateInput1 != undefined  ) {
      this.filters.ship_date = {
        operator: this.filterShipDateSelect,
        operands: [ this.filterShipDateInput1.formatted ]
      }

      if( this.filterShipDateSelect === 'inbetween' ) {
        this.filters.ship_date.operands.push( this.filterShipDateInput2.formatted );
      }
    }

    if( this.filterArrivalDate && this.filterArrivalDateInput1 != undefined ) {
      this.filters.arrival_date = {
        operator: this.filterArrivalDateSelect,
        operands: [ this.filterArrivalDateInput1.formatted ]
      }

      if( this.filterArrivalDateSelect === 'inbetween' ) {
        this.filters.arrival_date.operands.push( this.filterArrivalDateInput2.formatted );
      }
    }

    if( this.filterEquipmentId ) {
      this.filters.equipment_id = this.filterEquipmentIdValue
    }

    if( this.filterReferenceNumber ) {
      this.filters.reference_number = this.filterReferenceNumberValue
    }

    this.updateAppliedFilterCount();
    this.isFiltering = true;
  }
}
